import { Store } from "@redotech/util/store";
import { useState } from "react";
import { useHandler } from "./hook";

/**
 * Store-backed state
 */
export function useStore<T>(store: Store<T>): [T, (value: T) => void] {
  const [value, setValue] = useState(() => store.get());
  const setStore = useHandler((value: T) => {
    setValue(value);
    store.set(value);
  });
  return [value, setStore];
}
